import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import logo from '../assets/logo.png';
import bannerImage from '../assets/classroom1.png';
import media1 from '../assets/bg-hbo-bedrijfskunde.jpg';
import media2 from '../assets/bg-master-cluster.jpg';
import media3 from '../assets/masterclasses-subs.jpg';
import media4 from '../assets/classroom2.jpeg';
import media5 from '../assets/classroom3.jpeg';
import media6 from '../assets/classroom4.jpeg';
import info from '../assets/praktische info.jpeg';
import kwaliteit1 from '../assets/kwaliteit.1.png';
import kwaliteit2 from '../assets/kwaliteit.2.png';
import { contentAPI } from '../services/api';
import './Home.css';

const TEAM_SECTIONS = [
  { key: 'management_staff', title: 'Management en Staf' },
  { key: 'docenten', title: 'Docenten' },
  { key: 'commissies', title: 'Commissies' }
];

const REVIEW_SECTIONS = [
  { key: 'hbo', title: 'HBO' },
  { key: 'masterclasses', title: 'Masterclasses' },
  { key: 'masteropleidingen', title: 'Masteropleidingen' }
];

const normalizeTeamGroup = (value) => {
  if (value === 'management_staff' || value === 'directie') return 'management_staff';
  if (value === 'docenten' || value === 'docent') return 'docenten';
  if (value === 'commissies' || value === 'commissie') return 'commissies';
  return 'docenten';
};

const normalizeReviewCategory = (value) => {
  if (value === 'hbo' || value === 'bachelor') return 'hbo';
  if (value === 'masterclasses' || value === 'masterclass') return 'masterclasses';
  if (value === 'masteropleidingen' || value === 'masteropleiding') return 'masteropleidingen';
  if (value === 'hbo_masterclasses' || value === 'hbo-masterclasses') return 'hbo';
  return 'hbo';
};

const Home = () => {
  const [publicContent, setPublicContent] = useState({ teamMembers: [], reviews: [], flyers: [] });
  const [contentLoadError, setContentLoadError] = useState(false);
  const [activeFlyerPreview, setActiveFlyerPreview] = useState(null);

  const groupedTeamMembers = TEAM_SECTIONS.map((section) => ({
    ...section,
    items: publicContent.teamMembers.filter((member) => normalizeTeamGroup(member.group) === section.key)
  })).filter((section) => section.items.length > 0);

  const groupedReviews = REVIEW_SECTIONS.map((section) => ({
    ...section,
    items: publicContent.reviews.filter((review) => normalizeReviewCategory(review.category) === section.key)
  })).filter((section) => section.items.length > 0);

  useEffect(() => {
    let isMounted = true;

    const loadPublicContent = async () => {
      try {
        const response = await contentAPI.getPublic();
        if (isMounted) {
          setContentLoadError(false);
          setPublicContent({
            teamMembers: response.teamMembers || [],
            reviews: response.reviews || [],
            flyers: response.flyers || []
          });
        }
      } catch (error) {
        // Keep homepage available when content API is empty or temporarily unavailable.
        if (isMounted) {
          setContentLoadError(true);
          setPublicContent({ teamMembers: [], reviews: [], flyers: [] });
        }
      }
    };

    loadPublicContent();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!activeFlyerPreview) return undefined;

    const handleEscapeClose = (event) => {
      if (event.key === 'Escape') {
        setActiveFlyerPreview(null);
      }
    };

    window.addEventListener('keydown', handleEscapeClose);
    return () => window.removeEventListener('keydown', handleEscapeClose);
  }, [activeFlyerPreview]);

  return (
    <div className="public-home-page">
      <Navbar />
      <section className="home-hero">
        <div className="home-hero-inner">
          <div className="home-hero-copy">
            <img src={logo} alt="NLBA logo" className="home-logo" />
            <h1>NLBA Suriname</h1>
            <p>
              HBO- en masteropleidingen in deeltijd voor werkende professionals,
              praktijkgericht en met persoonlijke begeleiding in Paramaribo en Nickerie.
            </p>
            <div className="home-hero-actions">
              <Link to="/brochures/hbo" className="home-btn home-btn-primary">Bekijk brochures</Link>
              <Link to="/over-nlba" className="home-btn home-btn-secondary">Lees meer over NLBA</Link>
            </div>
          </div>
          <img src={bannerImage} alt="NLBA campus en lesomgeving" className="home-hero-image" />
        </div>
      </section>

      <section className="home-highlight-grid">
        <article className="home-highlight-card home-highlight-program-card">
          <img src={media1} alt="HBO Bedrijfskunde klaslokaal" className="home-highlight-image" />
          <h2>HBO Bedrijfskunde (BBA)</h2>
          <p>
            Praktijkgerichte bacheloropleiding voor professionals die willen doorgroeien
            in management, organisatieontwikkeling en ondernemerschap.
          </p>
          <Link to="/brochures/hbo" className="home-btn home-btn-primary small">
            Bekijk BBA brochures
          </Link>
        </article>

        <article className="home-highlight-card home-highlight-program-card">
          <img src={media2} alt="Masteropleidingen business omgeving" className="home-highlight-image" />
          <h2>Masteropleidingen</h2>
          <p>
            Verdiep je strategische en leiderschapsvaardigheden met flexibele
            mastertrajecten die aansluiten op jouw werkpraktijk.
          </p>
          <Link to="/brochures/master" className="home-btn home-btn-primary small">
            Bekijk master brochures
          </Link>
        </article>

        <article className="home-highlight-card home-highlight-program-card">
          <img src={media3} alt="Masterclass zakelijke training" className="home-highlight-image" />
          <h2>Masterclasses</h2>
          <p>
            Korte, intensieve businessprogramma's rond actuele thema's zoals
            leiderschap, coaching en verandermanagement.
          </p>
          <Link to="/brochures/masterclasses" className="home-btn home-btn-primary small">
            Bekijk masterclass brochures
          </Link>
        </article>

      </section>

      <section className="home-finance-section">
        <div className="home-finance-inner">
          <h2>Studiefinanciering</h2>
          <p>
            Door verder te studeren vergroot je je kansen op een beter en welvarend leven.
            Studeren is een levenslange investering in tijd en geld. De NOB biedt
            studieleningen tegen lage rentes en met soepele voorwaarden.
          </p>
          <p>
            Een universitaire opleiding of hoger beroepsonderwijs komt hiermee binnen bereik
            van veel Surinamers. Ook voor personen die in Suriname zijn geboren en bezig zijn
            met naturalisatie, zijn er mogelijkheden.
          </p>
          <p>
            Bekijk alle details en voorwaarden op onze pagina{' '}
            <Link to="/studiefinanciering" className="home-inline-link">
              Studiefinanciering
            </Link>
            .
          </p>
        </div>
      </section>

      <section className="home-practical-section">
        <div className="home-practical-media">
          <img src={media4} alt="NLBA leeromgeving 2" />
          <img src={media5} alt="NLBA leeromgeving 3" className="home-media3-tall" />
          <img src={media6} alt="NLBA leeromgeving 4" />
        </div>

        <div className="home-practical-content">
          <img src={info} alt="NLBA logo" className="home-practical-logo" />
        </div>
      </section>

      <section className="home-flyers-section">
        <div className="home-flyers-inner">
          <h2>Flyers & Updates</h2>
          {contentLoadError && (
            <p className="home-flyers-note">
              Flyers konden niet worden geladen. Controleer of de backend actief is en de frontend naar de juiste API wijst.
            </p>
          )}
          {publicContent.flyers.length === 0 && !contentLoadError && (
            <p className="home-flyers-note">Nog geen flyers beschikbaar.</p>
          )}
          {publicContent.flyers.length > 0 && (
            <div className="home-flyers-grid">
              {publicContent.flyers.map((flyer) => (
                <article key={flyer.id} className="home-flyer-card">
                  <button
                    type="button"
                    className="home-flyer-image-button"
                    onClick={() => setActiveFlyerPreview({
                      title: flyer.title,
                      imageUrl: contentAPI.flyerImageUrl(flyer.id)
                    })}
                    aria-label={`Vergroot flyer: ${flyer.title}`}
                  >
                    <img
                      src={contentAPI.flyerImageUrl(flyer.id)}
                      alt={flyer.title}
                      className="home-flyer-image"
                      loading="lazy"
                    />
                  </button>
                  <h3>{flyer.title}</h3>
                  {flyer.description && <p>{flyer.description}</p>}
                  {flyer.ctaUrl && (
                    <a href={flyer.ctaUrl} target="_blank" rel="noopener noreferrer" className="home-inline-link">
                      Meer informatie
                    </a>
                  )}
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      {(publicContent.teamMembers.length > 0 || publicContent.reviews.length > 0) && (
        <section className="home-community-section">
          <div className="home-community-inner">
            {publicContent.teamMembers.length > 0 && (
              <div className="home-team-block">
                <h2>Ons Team</h2>
                {groupedTeamMembers.map((section) => (
                  <div className="home-group-section" key={section.key}>
                    <h3 className="home-group-title">{section.title}</h3>
                    {section.key !== 'commissies' && (
                      <div className="home-team-grid">
                        {section.items.map((member) => (
                          <article key={member.id} className="home-team-card">
                            {member.hasPhoto && (
                              <img
                                src={contentAPI.teamMemberPhotoUrl(member.id)}
                                alt={member.name}
                                className="home-team-photo"
                                loading="lazy"
                              />
                            )}
                            <h3>{member.name}</h3>
                            {member.title && <p>{member.title}</p>}
                            {member.role && <p className="home-team-role">{member.role}</p>}
                          </article>
                        ))}
                      </div>
                    )}

                    {section.key === 'commissies' && (
                      Object.entries(
                        section.items.reduce((accumulator, member) => {
                          const subSegment = String(member.commissieType || '').trim() || 'Algemene commissie';
                          if (!accumulator[subSegment]) {
                            accumulator[subSegment] = [];
                          }
                          accumulator[subSegment].push(member);
                          return accumulator;
                        }, {})
                      ).map(([subSegment, members]) => (
                        <div key={subSegment} className="home-committee-subsection">
                          <h4 className="home-committee-subtitle">{subSegment}</h4>
                          <div className="home-team-grid">
                            {members.map((member) => (
                              <article key={member.id} className="home-team-card">
                                {member.hasPhoto && (
                                  <img
                                    src={contentAPI.teamMemberPhotoUrl(member.id)}
                                    alt={member.name}
                                    className="home-team-photo"
                                    loading="lazy"
                                  />
                                )}
                                <h4>{member.name}</h4>
                                {member.title && <p>{member.title}</p>}
                                {member.role && <p className="home-team-role">{member.role}</p>}
                              </article>
                            ))}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                ))}
              </div>
            )}

            {publicContent.reviews.length > 0 && (
              <div className="home-reviews-block">
                <h2>Studentrecensies</h2>
                {groupedReviews.map((section) => (
                  <div className="home-group-section" key={section.key}>
                    <h3 className="home-group-title">{section.title}</h3>
                    <div className="home-reviews-grid">
                      {section.items.map((review) => (
                        <article key={review.id} className="home-review-card">
                          <p className="home-review-quote">"{review.quote}"</p>
                          <div className="home-review-author">
                            {review.hasPhoto && (
                              <img
                                src={contentAPI.reviewPhotoUrl(review.id)}
                                alt={review.name}
                                className="home-review-photo"
                                loading="lazy"
                              />
                            )}
                            <div>
                              <strong>{review.name}</strong>
                              {review.role && <p>{review.role}</p>}
                            </div>
                          </div>
                        </article>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      )}

      <section className="home-accreditation-section">
        <div className="home-accreditation-inner">
          <h2>Erkend Onderwijs</h2>
          <p>NLBA Suriname voldoet aan internationaal geaccepteerde kwaliteitsnormen</p>
          <div className="home-accreditation-logos">
            <div className="home-accreditation-logo-item">
              <img src={kwaliteit1} alt="Accreditatie logo 1" loading="lazy" />
            </div>
            <div className="home-accreditation-logo-item">
              <img src={kwaliteit2} alt="Accreditatie logo 2" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {activeFlyerPreview && (
        <div
          className="home-flyer-modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Flyer voorbeeld"
          onClick={() => setActiveFlyerPreview(null)}
        >
          <div className="home-flyer-modal" onClick={(event) => event.stopPropagation()}>
            <div className="home-flyer-modal-header">
              <h3>{activeFlyerPreview.title}</h3>
              <button
                type="button"
                className="home-flyer-modal-close"
                onClick={() => setActiveFlyerPreview(null)}
                aria-label="Sluiten"
              >
                x
              </button>
            </div>
            <img src={activeFlyerPreview.imageUrl} alt={activeFlyerPreview.title} className="home-flyer-modal-image" />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Home;
